export const formatRelativeTime = (input: string | number | Date) => {
  const date = input instanceof Date ? input : new Date(input);
  const timestamp = date.getTime();
  if (Number.isNaN(timestamp)) {
    return 'Invalid date';
  }

  const now = Date.now();
  const diffMs = timestamp - now;
  const diffSeconds = Math.round(diffMs / 1000);

  const divisions: Array<{ amount: number; unit: Intl.RelativeTimeFormatUnit }> = [
    { amount: 60, unit: 'second' },
    { amount: 60, unit: 'minute' },
    { amount: 24, unit: 'hour' },
    { amount: 7, unit: 'day' },
    { amount: 4.34524, unit: 'week' },
    { amount: 12, unit: 'month' },
    { amount: Number.POSITIVE_INFINITY, unit: 'year' }
  ];

  let duration = diffSeconds;
  let unit: Intl.RelativeTimeFormatUnit = 'second';

  for (let index = 0; index < divisions.length; index += 1) {
    const division = divisions[index];
    if (Math.abs(duration) < division.amount || !Number.isFinite(division.amount)) {
      unit = division.unit;
      break;
    }
    duration /= division.amount;
  }

  const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });
  return rtf.format(Math.round(duration), unit);
};
